// extracted by mini-css-extract-plugin
export default {"container":"Drafts_container__Nmyk4"};